import { useState } from 'react';
import { User } from 'lucide-react';
import { cn } from '@reflex/ui/lib/utils';

export function UserAvatar({
  userName,
  avatarUrl,
  size = 'sm',
  className,
}: {
  userId?: string;
  userName?: string;
  avatarUrl?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const [imgError, setImgError] = useState(false);
  const sizes = {
    xs: 'h-4 w-4 text-3xs',
    sm: 'h-7 w-7 text-3xs',
    md: 'h-8 w-8 text-xs',
    lg: 'h-16 w-16 text-lg',
  } as const;
  if (avatarUrl && !imgError)
    return (
      <img
        src={avatarUrl}
        alt={userName ?? ''}
        className={cn(
          // Border, not ring: avatars routinely sit flush against a clipping
          // edge — the chat transcript gives every row `content-visibility:
          // auto`, whose paint containment clips to the row's padding edge — and
          // a ring paints outside the border box, so it loses whichever side is
          // flush. A border paints inside and survives any such ancestor.
          'shrink-0 rounded-full border border-border object-cover',
          sizes[size],
          className,
        )}
        onError={() => setImgError(true)}
      />
    );
  return (
    <span
      className={cn(
        // Border, not ring, for the reason given on the image branch above.
        'flex shrink-0 items-center justify-center rounded-full border border-border bg-muted font-medium text-muted-foreground',
        sizes[size],
        className,
      )}
    >
      {userName ? userName.charAt(0).toUpperCase() : <User className="h-1/2 w-1/2" />}
    </span>
  );
}
